import PropTypes from 'prop-types';

const locationModel = () => {
  PropTypes.shape({
    pathname: PropTypes.string.isRequired
  });
};

export default locationModel;
